export enum LgTraining {
  Lg1 = 'lg1',
  Lg2 = 'lg2',
  Both = 'both',
  InProgress = 'in-progress',
  None = 'none',
}
